import dhid from '../../../dhid';

const redirectToESLLogin = () => {
  // We experienced a issue with the URL and double slashes. (.com//)
  // This causes a 404, meaning the whole login process fails.
  // Make sure the provided URL doesn't end with '//'
  const baseUrl = dhid.getBaseUrl().replace(/\/+$/, '');

  // Expected => "/login/?returnUrl" (0/1/2)
  const returnUrl = window.location.pathname.split('/')[2] ?? '';

  const returnPath = `/login/redirect/${returnUrl}`;
  window.location.href = `${baseUrl}/login/esl?return_path=${returnPath}`;
};

export default redirectToESLLogin;
